var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27143 50.5C6.27143 75.2029 26.2971 95.2286 51 95.2286C75.7029 95.2286 95.7286 75.2029 95.7286 50.5C95.7286 25.7971 75.7029 5.77143 51 5.77143C26.2971 5.77143 6.27143 25.7971 6.27143 50.5ZM51 0C23.1096 0 0.5 22.6096 0.5 50.5C0.5 78.3904 23.1096 101 51 101C78.8904 101 101.5 78.3904 101.5 50.5C101.5 22.6096 78.8904 0 51 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0913 22.7094L52.5838 17.6684C52.1694 16.7931 50.8731 16.7614 50.4162 17.6684L47.9088 22.7094L42.3519 23.5004C41.3638 23.648 40.9388 24.8608 41.6719 25.5885L45.7094 29.4906L44.7531 34.9851C44.6044 35.9659 45.6244 36.7252 46.5381 36.2717L51.5213 33.6563L56.4725 36.2295C57.3862 36.683 58.4169 35.9237 58.2575 34.9429L57.3013 29.4484L61.3388 25.5885C62.0613 24.8714 61.6469 23.6586 60.6588 23.5004L55.1019 22.7094H55.0913ZM44.7 44.002C42.8194 44.002 41.3 45.5101 41.3 47.3768V67.6252C41.3 69.4919 42.8194 71 44.7 71H58.3C60.1806 71 61.7 69.4919 61.7 67.6252V47.3768C61.7 45.5101 60.1806 44.002 58.3 44.002H44.7ZM20.9 50.7515C19.0194 50.7515 17.5 52.2596 17.5 54.1263V67.6252C17.5 69.4919 19.0194 71 20.9 71H34.5C36.3806 71 37.9 69.4919 37.9 67.6252V54.1263C37.9 52.2596 36.3806 50.7515 34.5 50.7515H20.9ZM65.1 60.8757V67.6252C65.1 69.4919 66.6194 71 68.5 71H82.1C83.9806 71 85.5 69.4919 85.5 67.6252V60.8757C85.5 59.0091 83.9806 57.501 82.1 57.501H68.5C66.6194 57.501 65.1 59.0091 65.1 60.8757Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardIcon);
export default __webpack_public_path__ + "static/media/leaderboard-icon.b50b06c441cd97b28d5de23fb98598dd.svg";
export { ForwardRef as ReactComponent };